import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "label"]

  copy() {
    const text = this.sourceTarget.value || this.sourceTarget.textContent

    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => this.showFeedback()).catch(() => this.fallbackCopy(text))
    } else {
      this.fallbackCopy(text)
    }
  }

  fallbackCopy(text) {
    const ta = document.createElement("textarea")
    ta.value = text
    ta.style.position = "fixed"
    ta.style.opacity = "0"
    document.body.appendChild(ta)
    ta.select()
    try { document.execCommand("copy"); this.showFeedback() } catch (e) { /* ignore */ }
    document.body.removeChild(ta)
  }

  showFeedback() {
    if (!this.hasLabelTarget) return
    const original = this.labelTarget.textContent
    this.labelTarget.textContent = this.labelTarget.dataset.copiedText || "✓ Copied!"
    setTimeout(() => { this.labelTarget.textContent = original }, 2000)
  }
}
